import { Routes } from '@angular/router';
import { authGuard, adminGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'tracking', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./components/shell/shell.component').then(m => m.ShellComponent),
    children: [
      {
        path: 'tracking',
        loadComponent: () =>
          import('./pages/tracking/tracking.component').then(m => m.TrackingComponent),
      },
      {
        path: 'weekly-recap',
        loadComponent: () =>
          import('./pages/weekly-recap/weekly-recap.component').then(m => m.WeeklyRecapComponent),
      },
      {
        path: 'history',
        loadComponent: () =>
          import('./pages/history/history.component').then(m => m.HistoryComponent),
      },
      {
        path: 'projects',
        loadComponent: () =>
          import('./pages/projects/projects.component').then(m => m.ProjectsComponent),
      },
      {
        path: 'export',
        loadComponent: () =>
          import('./pages/export/export.component').then(m => m.ExportComponent),
      },
      {
        path: 'users',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./pages/users/users.component').then(m => m.UsersComponent),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/profile/profile.component').then(m => m.ProfileComponent),
      },
    ],
  },
  { path: '**', redirectTo: 'tracking' },
];
